import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { ChamadoChecklist, FormToFilling } from "../components/Filling/Types";
import { AuthBodyType } from "./types";
import { ItemChecklist } from "./Checklists";
import type { FormToFilling as RefactoredFormToFilling } from "../types/new-form-filling/types";
import type { ChamadoChecklist as RefactoredChamadoChecklist } from "../types/new-form-filling/types";

export type ChecklistAnonimoType = {
  abreChamado: {
    apos: boolean;
    durante: boolean;
  };
  dataAlteracao: number;
  dataCadastro: number;
  editavel: { cancela: boolean; clone: boolean };
  empresa: string;
  id: string;
  identificadorLista: string;
  itens: ItemChecklist;
  nome: string;
  preenchimentoDeslogado: boolean;
  preenchimentoWeb: boolean;
  status: boolean;
  userNome: string;
  versao: number;
};

type hierarquiaToSendType = {
  cliente: string;
  local: string;
  conjunto: string;
  unidade: string;
};

class Anonimo {


  executaChecklistAnonimo = async (checklist: FormToFilling | RefactoredFormToFilling, ocultos?: string[]) => {
    try {
      const check = { ...checklist };
      const data: AxiosResponse = await api.post("/anonimo/executaChecklistAnonimo", {
        checklist: check,
        ocultos,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  listaHistoricoAnonimo = async (body: AuthBodyType, formId: string, inicio: number, fim: number) => {
    try {
      const data: AxiosResponse = await api.post("/anonimo/listaHistoricoAnonimo", {
        ...body,
        formId,
        inicio,
        fim,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  listaModelosChecklistAnonimo = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/anonimo/listaModelosChecklistAnonimo", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        // toast.error(error.request?.status);
        return error.response?.status;
      }
    }
  };

  editaChamadoExecucao = async (
    body: AuthBodyType,
    formId: string,
    inicio: number,
    chamados: ChamadoChecklist[] | RefactoredChamadoChecklist[],
    itemId?: number | boolean | null,
    subId?: number | boolean | null,
    hierarquia?: hierarquiaToSendType | null
  ) => {
    try {
      const data: AxiosResponse = await api.post("/anonimo/editaChamadoExecucao", {
        ...body,
        formId,
        inicio,
        itemId,
        subId,
        chamados,
        hierarquia,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  executaChecklistLogado = async (
    body: AuthBodyType,
    hierarquia: {
      cliente: string;
      local: string;
      conjunto: string;
      unidade: string;
    },
    checklist: FormToFilling | RefactoredFormToFilling
  ) => {
    try {
      const data: AxiosResponse = await api.post("/anonimo/executaChecklistLogado", {
        ...body,
        hierarquia,
        checklist,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}

export default Anonimo;
